import React, { useState, useEffect } from "react";
import useApiServices from "../../utils/useApiServices";
import swal from "sweetalert";
import { TELEGRAM_API_BASE_URL } from "../../utils/constant";

function SendBoxx() {
  const [message, setMessage] = useState("");
  const [merchantGroups, setMerchantGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [sendingRow, setSendingRow] = useState(null);

  const { apiCallFnforPostForOpenUrl, apiCallFnforGetOpenUrl2 } =
    useApiServices();

  useEffect(() => {
    fetchGroups();
  }, []);

  const fetchGroups = async () => {
    try {
      const res = await apiCallFnforGetOpenUrl2(
        `${TELEGRAM_API_BASE_URL}/merchant-group/getAllMerchantGroup`
      );
      if (res?.statusCode === 200) {
        setMerchantGroups(res?.data || []);
      } else {
        throw new Error("Failed to load groups from server");
      }
    } catch (err) {
      setError("Unable to load Telegram groups");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setSelectedGroups(newSelectAll ? merchantGroups.map((g) => g.chatId) : []);
  };

  const handleCheckboxChange = (chatId) => {
    setSelectedGroups((prev) =>
      prev.includes(chatId)
        ? prev.filter((id) => id !== chatId)
        : [...prev, chatId]
    );
  };

  const handleSendBroadcast = async (groupIds) => {
    if (!message.trim() || groupIds.length === 0) {
      setError("Please enter a message and select at least one group.");
      return;
    }

    setSending(true);
    setError("");

    try {
      const res = await apiCallFnforPostForOpenUrl(
        `${TELEGRAM_API_BASE_URL}/send-message/sendMessageAllSelectedGroup`,
        {
          message,
          groupChatIds: groupIds,
        }
      );

      if (res.statusCode === 200) {
        swal({
          title: "Success",
          text: "Broadcast sent successfully!",
          icon: "success",
          button: "OK",
        });
        setMessage("");
        setSelectedGroups([]);
        setSelectAll(false);
      } else {
        swal({
          title: "Failed",
          text: "Failed to send broadcast.",
          icon: "error",
          button: "OK",
        });
      }
    } catch (err) {
      setError("Failed to send broadcast.");
    } finally {
      setSending(false);
      setSendingRow(null);
    }
  };

  return (
      <div className="card shadow border-0 p-4">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">📢 Send Telegram Broadcast</h5>
        </div>

        <div className="card-body">
          {loading && <p className="text-muted">Loading groups...</p>}
          {error && <div className="alert alert-danger">{error}</div>}

          {/* Message Input */}
          <div className="mb-4 text-start">
            <label className="form-label fw-semibold fs-3">
              Broadcast Message
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter your message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
          <div className="table-responsive">
            <table className="table table-striped table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>
                    {!loading && merchantGroups.length > 0 && (
                      <div className="form-check mb-3 d-flex align-items-center justifu-content-center">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="selectAll"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />
                      </div>
                    )}
                  </th>
                  <th>Group</th>
                  <th>Company</th>
                  <th>Chat ID</th>
                  {selectedGroups.length <= 1 && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {merchantGroups.map((group) => {
                  const isSelected = selectedGroups.includes(group.chatId);
                  return (
                    <tr key={group.chatId}>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={isSelected}
                          onChange={() => handleCheckboxChange(group.chatId)}
                        />
                      </td>
                      <td>{group.groupName}</td>
                      <td>{group.companyName}</td>
                      <td>{group.chatId}</td>
                      {selectedGroups.length <= 1 && (
                        <td>
                          <button
                            className="btn btn-primary btn-sm"
                            disabled={
                              sendingRow === group.chatId || !message.trim()
                            }
                            onClick={() => {
                              setSendingRow(group.chatId);
                              handleSendBroadcast([group.chatId]);
                            }}
                          >
                            {sendingRow === group.chatId
                              ? "Sending..."
                              : "Send"}
                          </button>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Global Send Button */}
          {selectedGroups.length > 1 && (
            <div className="text-end mt-3">
              <button
                className="btn btn-success"
                onClick={() => handleSendBroadcast(selectedGroups)}
                disabled={sending || !message.trim()}
              >
                {sending
                  ? "Sending to All..."
                  : `🚀 Send to ${selectedGroups.length} Groups`}
              </button>
            </div>
          )}
        </div>
      </div>

  );
}

export default SendBoxx;
